<template>
  <div class="content sub">
    <div class="inner_box">
      <h2 class="title_sub2">
        “{{ state.keyword }}” 검색결과
      </h2>

      <tab-list-01
        v-model="selectTab"
        :list="tabList"
        @select="handleUpdateTab"
      />

      <NuxtPage :page-key="route => route.fullPath" keep-alive />
    </div>
  </div>
</template>

<script setup lang="ts">
import PATH from '~/modules/content/config/content-path'
import contentSortMiddleware from '~/modules/content/middleware/content-sort-middleware'

import { SEARCH_TYPE } from '~/modules/content/types/type'
import useContentNavigator from '~/modules/content/composables/navigate'

definePageMeta({
  layout: 'default',
  middleware: [contentSortMiddleware]
})

const route = useRoute()
const { navigateToSearchBussiness, navigateToSearchContents } = useContentNavigator()

const selectTab = ref(SEARCH_TYPE.CONTENTS)
const tabList = ref<any[]>([
  { id: SEARCH_TYPE.CONTENTS, title: '콘텐츠' },
  { id: SEARCH_TYPE.BUSINESS, title: '기업' }
])

const state = reactive({ keyword: '', searchAffectType: '' })

onBeforeMount(() => init())

watch(() => route.fullPath, () => {
  init()
})

const init = () => {
  selectTab.value = route.path === PATH.SEARCH_CONTENTS ? SEARCH_TYPE.CONTENTS : SEARCH_TYPE.BUSINESS
  state.keyword = route.query.keyword?.toString() ?? ''
  state.searchAffectType = route.query.search_affect_type?.toString() ?? ''
}

/**
 * 탭 클릭 변경 여부
 */
const handleUpdateTab = (tabId: string) => {
  if (tabId === SEARCH_TYPE.CONTENTS) {
    navigateToSearchContents(state.keyword, state.searchAffectType)
  } else {
    navigateToSearchBussiness(state.keyword)
  }
}

</script>

<style scoped>
.content.sub{position:relative;padding:40px 0 100px;}

@media screen and (max-width: 768px) {
  .content.sub{padding:12px 0 80px;}
}
</style>
